import { render, staticRenderFns } from "./done.vue?vue&type=template&id=481d5038&scoped=true&"
import script from "./done.vue?vue&type=script&lang=js&"
export * from "./done.vue?vue&type=script&lang=js&"
import style0 from "./done.vue?vue&type=style&index=0&id=481d5038&scoped=true&lang=css&"
import style1 from "./done.vue?vue&type=style&index=1&id=481d5038&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481d5038",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\myProject\\cbi-site-front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('481d5038')) {
      api.createRecord('481d5038', component.options)
    } else {
      api.reload('481d5038', component.options)
    }
    module.hot.accept("./done.vue?vue&type=template&id=481d5038&scoped=true&", function () {
      api.rerender('481d5038', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/workplace/supervision/orderRepair/components/done.vue"
export default component.exports